export const TEXTFIELD_WIDTH_PADDING = 5;
